import { object, array, boolean, number } from '@gogame/schemas';

import {
  ANNOTATIONS_SETTINGS_MINE_ONLY,
  ANNOTATIONS_SETTINGS_SHOW,
  ANNOTATIONS_SETTINGS_SUB_TYPES,
  ANNOTATIONS_SETTINGS_TYPE,
} from './constants';

export const annotationsSchema = object({
  [ANNOTATIONS_SETTINGS_SHOW]: boolean().default(false),
  [ANNOTATIONS_SETTINGS_TYPE]: number().default(-1),
  [ANNOTATIONS_SETTINGS_SUB_TYPES]: array(number()).default([]),
  [ANNOTATIONS_SETTINGS_MINE_ONLY]: boolean().default(false),
});
